import { render, staticRenderFns } from "./contentVideo.vue?vue&type=template&id=f5f2c06e&"
import script from "./contentVideo.vue?vue&type=script&lang=js&"
export * from "./contentVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports